var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pb-5" },
    [
      _vm._t("header"),
      _vm.isEmptyListPlaceholderShown
        ? _c(
            "EmptyListPlaceholder",
            {
              attrs: {
                title: _vm.emptyListTitle,
                subtitle: _vm.emptyListSubtitle,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "image",
                    fn: function () {
                      return [_c("EmptyListImageDocuments")]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                2273432899
              ),
            },
            [
              _vm._t("emptyListActions", null, {
                refetchDocuments: _vm.updateDocumentList,
              }),
            ],
            2
          )
        : _c(
            "div",
            [
              _vm.isDocumentsExist
                ? _c("ActionsPanelWithFilters", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "filters",
                          fn: function () {
                            return [
                              _vm._t("filtersFullBlock", function () {
                                return [
                                  _c("Search", {
                                    staticClass: "min-w-52 w-60 mr-4",
                                    attrs: {
                                      nameSearchStyle: "pl-8",
                                      placeholderText: "Search by file name",
                                      iconStyle: "customIcon",
                                      inputClass: "customFormInput",
                                    },
                                    on: { search: _vm.onSearch },
                                  }),
                                  _vm._t("filters"),
                                ]
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "actions",
                          fn: function () {
                            return [
                              _vm._t("actions", null, {
                                refetchDocuments: _vm.updateDocumentList,
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  })
                : _vm._e(),
              _c(
                "LoadingOverlay",
                {
                  attrs: {
                    hasData: !!_vm.documents,
                    loading: _vm.$apollo.loading,
                  },
                },
                [
                  _vm.isSearchResultEmpty
                    ? _c("EmptyListPlaceholder", {
                        attrs: { title: "No documents found for your request" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "image",
                              fn: function () {
                                return [_c("EmptyListImageDocuments")]
                              },
                              proxy: true,
                            },
                          ],
                          null,
                          false,
                          2273432899
                        ),
                      })
                    : _c(
                        "div",
                        [
                          _vm._t("default", function () {
                            return [
                              _c("DocumentTable", {
                                attrs: {
                                  documents: _vm.documents,
                                  currentUser: _vm.currentUser,
                                  customRequestId: _vm.customRequestId,
                                },
                                on: { documentDeleted: _vm.updateDocumentList },
                              }),
                            ]
                          }),
                        ],
                        2
                      ),
                ],
                1
              ),
            ],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }